exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".checkbox {\n  width: 100%;\n  display: flex;\n  align-items: center; }\n  .checkbox .box {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    height: 3rem;\n    width: 3rem;\n    border-radius: 50%;\n    background: #f4f4f4;\n    border: 1px solid #a1a1a1;\n    margin-right: 1.8rem; }\n    .checkbox .box .anticon {\n      font-size: 1.65em;\n      color: #f4f4f4; }\n  .checkbox .box.checked {\n    background: #ef3d42;\n    border: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/Shared/Checkbox/Checkbox.scss
// module id = 1454
// module chunks = 0